// src/components/Body/styles.ts
var bodySizesSx = {
  regular: {
    fontSize: "var(--fontSizes-bodyRegular)",
    lineHeight: "var(--lineHeights-bodyRegular)"
  },
  small: {
    fontSize: "var(--fontSizes-bodySmall)",
    lineHeight: "var(--lineHeights-bodySmall)"
  }
};

export {
  bodySizesSx
};
